var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"scale","mode":"out-in"}},[(_vm.isPassed)?_c('Layout'):_c('Login',{attrs:{"password":_vm.password},on:{"pass":_vm.pass}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }